<template>
  <div>
    <!-- Table Data -->
    <div>
      <vs-table id="admin-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @change-page="handleChangePage" @sort="handleSort" :total="adminFilteredCount" :max-items="length"
        :data="adminRecords">
        <template slot="header">
          <!-- Per Page Record -->
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (adminFilteredCount && 1)) || 0 }}
                      -
                      {{ adminFilteredCount - page * length > 0 ? page * length : adminFilteredCount }}
                      of {{ adminTotal || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div v-if="checkPermissionSlug(['gurudwara_admin_list'])" @click.stop="inviteMember()"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base border-primary">Add {{ module_name }}</span>
            </div>
          </div>
        </template>

        <!-- Table Header -->
        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Email</vs-th>
          <vs-th>Mobile Number</vs-th>
          <vs-th>Handle Name</vs-th>
          <vs-th v-if="checkPermissionSlug(['gurudwara_admin_revoke'])">Action</vs-th>
        </template>

        <!-- Table Data Display -->
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.email || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.mobile || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.handle_name || '-' }}</span>
            </vs-td>
            <vs-td v-if="checkPermissionSlug(['gurudwara_admin_revoke'])">
              <div class="inline-flex">
                <vx-tooltip v-if="checkPermissionSlug(['gurudwara_admin_revoke'])"
                  :text="`${module_name} Accees Revoke`">
                  <feather-icon @click.stop="revokeAccess(tr._id, `${tr.email}`)" icon="UserXIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- Custom Pagination -->
      <vs-pagination v-if="adminFilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5"
        class="mt-8"></vs-pagination>
    </div>
    <vs-popup button-accept="false" button-cancel="false" :active.sync="popupActive" :title="`Invite Gurudwara Admin`">
      <div class="vx-row px-5 vs-con-loading__container">
        <div class="vx-col px-0 w-full">
          <!-- Loop through email, mobile, and handle name inputs -->
          <div v-for="(entry, index) in form.email" :key="index" class="mt-2 mb-3">
            <label :for="'Email-' + index">Email {{ index + 1 }}</label>
            <div class="flex justify-between flex-wrap">
              <!-- Email Input -->
              <div class="w-full mb-2">
                <vs-input :id="'Email-' + index" class="w-full" v-model="entry.email" v-validate="'required|email'"
                  :name="'Email-' + index" icon="icon icon-mail" icon-pack="feather" placeholder="Please add Email"
                  data-vv-as="Email" @input="debouncedLookupByEmail(entry, index)" />
                <span class="text-danger text-sm" v-show="errors.has('Email-' + index)">
                  {{ errors.first('Email-' + index) }}
                </span>
              </div>

              <!-- Mobile Input -->
              <div class="w-full mb-2">
                <vs-input :id="'Mobile-' + index" class="w-full" v-model="entry.mobile"
                  @input="debouncedCheckMobile(entry.mobile, index)"
                  v-validate="'required|numeric'"
                  :name="'Mobile-' + index" icon="icon icon-smartphone" icon-pack="feather"
                  placeholder="Please add Mobile Number" data-vv-as="Mobile" />
                <span class="text-danger text-sm" v-show="errors.has('Mobile-' + index)">
                  {{ errors.first('Mobile-' + index) }}
                </span>
              </div>

              <!-- Handle Name Input -->
              <div class="w-full">
                <vs-input :id="'Handle-' + index" class="w-full" v-model="entry.handle_name" v-validate="'required'"
                  :name="'Handle-' + index" icon="icon icon-user" disabled icon-pack="feather"
                  placeholder="Please add Handle Name" data-vv-as="Handle Name" />
                <span class="text-danger text-sm" v-show="errors.has('Handle-' + index)">
                  {{ errors.first('Handle-' + index) }}
                </span>
              </div>

              <!-- Remove Button -->
              <div class="w-full flex justify-end mt-2">
                <vx-tooltip :text="`Remove`">
                  <vs-button @click="removeEmail(index)" color="danger" type="gradient" icon-pack="feather"
                    icon="icon-trash-2" />
                </vx-tooltip>
              </div>
            </div>
          </div>

          <!-- Add Email Button -->
          <div class="mt-3 mb-3 flex justify-start">
            <vx-tooltip :text="`Add Email`">
              <vs-button @click="addEmail" color="primary" type="filled" icon-pack="feather" icon="icon-plus">Add another email</vs-button>
            </vx-tooltip>
          </div>

          <!-- Action Buttons -->
          <div class="mt-12">
            <div class="w-full px-0 justify-items-center">
              <vs-button class="text-sm py-3 px-5" color="dark" @click.stop="popupActive = false"> Cancel </vs-button>
              <vs-button
                class="ml-2 vs-con-loading__container text-sm vs-component vs-button vs-button-primary vs-button-filled py-3 px-5"
                id="invite-gurudwara" @click.stop="inviteGuruAdmin">
                Invite
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'adminList',

  mixins: [dateMixins],
  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    form: {
      email: [{ email: '', mobile: '', handle_name: '' }],
      gurudwara: ''
    },
    module_name: 'Gurudwara Admin',
    breadcrumb: [],
    popupActive: false
  }),

  /** Import State */
  computed: {
    ...mapGetters('auth', ['checkPermissionSlug']),
    ...mapState('gurudwara', ['adminRecords', 'adminTotal', 'adminFilteredCount', 'adminListLoading', 'createAdminLoading']),
    /** Page Number Show Logic ( Dynamic ) */
    totalPages() {
      return Math.ceil(this.adminFilteredCount / this.length)
    }
  },

  /** CTA functions */
  methods: {
    /** API Import */
    ...mapActions('gurudwara', {
      get: 'getGurudwaraAdmin',
      inviteAdmin: 'inviteAdmin',
      revokeAccessUser: 'revokeAccessUser',
      getHandleNameByMobile: 'getHandleNameByMobile'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        gurudwara: this.$route.params.id,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    /*** Invite member */
    inviteMember() {
      if (this.popupActive) {
        this.popupActive = false
      } else {
        this.popupActive = true
      }
    },

    addEmail() {
      this.form.email.push({ email: '', mobile: '', handle_name: '' })
    },

    removeEmail(index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete?`,
        accept: () => {
          this.form.email.splice(index, 1) // Remove the email input at the specified index
        },
        acceptText: 'Delete'
      })
    },

    /** Revoke gurudwara admin Confirmation */
    revokeAccess(id, name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Access Revoke`,
        text: `Are you sure you want to remove access '${name}' this record?`,
        accept: () => this.revokeAccessById(id),
        acceptText: 'Revoke Access'
      })
    },

    /** Revoke gurudwara admin API */
    async revokeAccessById(id) {
      try {
        const { message } = await this.revokeAccessUser({ gurudwaraId: this.$route.params.id, userId: id })
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },
    /** Invite Admin */
    async inviteGuruAdmin() {
      let valid = true
      for (let i = 0; i < this.form.email.length; i++) {
        const emailValid = await this.$validator.validate(`Email-${i}`)
        const mobileValid = await this.$validator.validate(`Mobile-${i}`)
        const handleValid = await this.$validator.validate(`Handle-${i}`)

        if (!emailValid || !mobileValid || !handleValid) {
          valid = false
        }
      }
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }

      if (!this.form.email.length) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please add at least one email',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const { message } = await this.inviteAdmin(this.form)
        this.form.email = [{ email: '', mobile: '', handle_name: '' }]
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.popupActive = false
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    // Debounced wrapper for mobile lookup — avoids firing on every keystroke (per row)
    debouncedCheckMobile(mobile, index) {
      if (!this._mobileTimers) this._mobileTimers = {}
      clearTimeout(this._mobileTimers[index])
      this._mobileTimers[index] = setTimeout(() => {
        this.checkMobileLength(mobile, index)
      }, 500)
    },

    checkMobileLength(mobile, index) {
      if (!mobile) {
        this.form.email[index].handle_name = ''
        return
      }
      // Trigger for 7+ digits to support international numbers
      // (e.g. Dubai: 9 digits, India: 10 digits)
      if (mobile.length >= 7) {
        this.fetchHandleNameByMobile(mobile, index)
      }
    },

    // Debounced wrapper for email lookup (per row so multiple invite lines work)
    debouncedLookupByEmail(entry, index) {
      if (!this._emailTimers) this._emailTimers = {}
      clearTimeout(this._emailTimers[index])
      this._emailTimers[index] = setTimeout(() => {
        this.lookupByEmail(entry.email, index)
      }, 600)
    },

    async lookupByEmail(email, index) {
      const trimmed = (email || '').trim()
      if (!trimmed || !trimmed.includes('@')) return
      const basicEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!basicEmail.test(trimmed)) return
      try {
        const response = await this.$store.dispatch('gurudwara/getHandleNameByMobile', trimmed)
        if (response && response.data) {
          if (response.data.handle_name) {
            this.form.email[index].handle_name = response.data.handle_name
          }
          if (response.data.mobile_number && !this.form.email[index].mobile) {
            this.form.email[index].mobile = response.data.mobile_number
          }
        }
      } catch (err) {
        // User not found by email — silently ignore
      }
    },

    async fetchHandleNameByMobile(mobile, index) {
      try {
        const response = await this.$store.dispatch('gurudwara/getHandleNameByMobile', mobile)
        if (response && response.data) {
          this.form.email[index].handle_name = response.data.handle_name || ''
          if (response.data.email && !this.form.email[index].email) {
            this.form.email[index].email = response.data.email
          }
        }
      } catch (err) {
        // User not found — silently ignore
      }
    }
  },

  /** Watchers */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    adminListLoading() {
      if (this.adminListLoading) {
        this.$vs.loading({
          container: '#admin-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#admin-list > .con-vs-loading')
      }
    },
    createAdminLoading() {
      if (this.createAdminLoading) {
        this.$vs.loading({
          container: '#invite-gurudwara',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#invite-gurudwara > .con-vs-loading')
      }
    },
    /** Page Loading when data retrive ( API Based ) */
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  async mounted() {
    this.form.gurudwara = this.$route.params.id
    this.getData()
    const gurudwaraId = this.$route.params.id

    if (gurudwaraId) {
      await this.$store.dispatch('gurudwara/show', gurudwaraId).then(async (res) => {
        const data = res.data.data
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Gurudwara', url: '/gurudwara/list' },
          { title: data.name, url: `/gurudwara/${gurudwaraId}/gurudwara-admin-list` },
          { title: 'Gurudwara Admin', active: true }
        ]
      })
    }
  }
}
</script>
<style>
.vs-tooltip {
  z-index: 9999999 !important;
}

.con-vs-dialog {
  z-index: 9999999 !important;
}
</style>
